import { BaseService } from "../../core/baseService";
import {
  TransferRequestServiceInterface,
  GetTransferRequestsParams,
  UpdateTransferRequestStatusParams,
  BulkUpdateTransferRequestStatusParams,
  BulkUpdateTransferRequestStatusResponse,
} from "../types/transfer.types";
import { AdminTransferRequest, PaginatedResponse } from "../../../models";
import { ApiResult, CountResponse, extractCount } from "../../core/types";

export class TransferRequestService
  extends BaseService
  implements TransferRequestServiceInterface
{
  async getPendingCount(): Promise<ApiResult<number>> {
    const result = await this.handleRequest<CountResponse>(
      this.client.get("/api/admin/transfer-requests/pending-count"),
    );
    return extractCount(result);
  }

  async getRequests(
    params: GetTransferRequestsParams,
  ): Promise<ApiResult<PaginatedResponse<AdminTransferRequest>>> {
    const { page, pageSize, sortField, sortOrder, status, roomNumber } = params;

    const queryParams: Record<string, unknown> = {
      pageNumber: page, // Note: API uses pageNumber, not page
      pageSize,
      sortField: sortField || "requestedAt",
      sortOrder: sortOrder || "desc",
    };

    if (status !== null && status !== undefined) {
      queryParams.status = status;
    }

    if (roomNumber) {
      queryParams.roomNumber = roomNumber;
    }

    return this.handleRequest<PaginatedResponse<AdminTransferRequest>>(
      this.client.get("/api/admin/transfer-requests", { params: queryParams }),
    );
  }

  async updateRequestStatus(
    params: UpdateTransferRequestStatusParams,
  ): Promise<ApiResult<AdminTransferRequest>> {
    const { requestId, status } = params;
    return this.handleRequest<AdminTransferRequest>(
      this.client.put(
        `/api/admin/transfer-requests/${requestId}/status`,
        status,
      ),
    );
  }

  async bulkUpdateRequestStatus(
    params: BulkUpdateTransferRequestStatusParams,
  ): Promise<ApiResult<BulkUpdateTransferRequestStatusResponse>> {
    const payload = {
      requestIds: params.requestIds,
      status: params.status.status,
      staffNotes: params.status.staffNotes,
      price: params.status.price,
      currency: params.status.currency,
    };
    return this.handleRequest<BulkUpdateTransferRequestStatusResponse>(
      this.client.put("/api/admin/transfer-requests/bulk-status", payload),
    );
  }
}
